export default {
    date: "تاریخ",
    identifiedNutritionRisk: "شناسایی خطر تغذیه",
    interventionProgram: "برنامه مداخله",
    outcome: "نتیجه",
}